/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Chat_Ask_User_SkippedInputs */



/**
* | output |
* | --- |
* | "Skipped" |
*
* @param {Chat_Ask_User_SkippedInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const chat_ask_user_skipped = /** @type {((inputs?: Chat_Ask_User_SkippedInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Chat_Ask_User_SkippedInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Übersprungen")
	return /** @type {LocalizedString} */ ("Skipped")
});